import { type PageLayoutData, LayoutNode } from 'shop-ui/types';
import cloneDeep from 'lodash-es/cloneDeep';
import { ELEMENT_TYPE } from 'shop-ui/constants';

export function mergeComponents(
    component1: PageLayoutData,
    component2: PageLayoutData,
    options?: {
        insertToId?: string | null;
    }
) {
    if (!options?.insertToId) {
        return {
            layout: [
                ...cloneDeep((component1.layout as LayoutNode[]) || []),
                ...cloneDeep(component2.layout as LayoutNode[]),
            ],
            style: { ...(component1.style || {}), ...component2.style },
            content: { ...(component1.content || {}), ...component2.content },
            site: component1.site || component2.site,
        };
    }

    const newLayout = [...cloneDeep(component1.layout as LayoutNode[])];

    let foundInsertToId = false;

    let inserted = false;

    function __sideEffect__insertComponentLayout(
        layout: LayoutNode | LayoutNode[],
        component: LayoutNode | LayoutNode[]
    ) {
        if (inserted) {
            return;
        }

        if (Array.isArray(layout)) {
            if (foundInsertToId) {
                layout.forEach((next) => {
                    __sideEffect__insertComponentLayout(next, component);
                });

                return;
            }

            const targetLayout = layout.find((item) => item.id === options?.insertToId);

            if (targetLayout) {
                foundInsertToId = true;

                __sideEffect__insertComponentLayout(targetLayout, component);
            }

            return;
        }

        if (layout.type === ELEMENT_TYPE.GRID_SECONDARY_LEVEL_INNER) {
            if (layout.next) {
                if (Array.isArray(component)) {
                    layout.next.push(...component);
                } else {
                    layout.next.push(component);
                }
            }

            if (!layout.next || !Array.isArray(layout.next)) {
                if (Array.isArray(component)) {
                    // eslint-disable-next-line no-param-reassign
                    layout.next = [...component];
                } else {
                    // eslint-disable-next-line no-param-reassign
                    layout.next = [component];
                }
            }

            inserted = true;

            return;
        }

        // @ts-ignore
        __sideEffect__insertComponentLayout(layout.next, component);
    }

    __sideEffect__insertComponentLayout(newLayout, component2.layout);

    return {
        layout: newLayout,
        style: { ...(component1.style || {}), ...component2.style },
        content: { ...(component1.content || {}), ...component2.content },
        site: component1.site || component2.site,
    };
}
